import { BaseComponent, BaseComponentAttrs } from "../base/baseComponent";
import { CompType } from "../base/baseEnum";

/** SEO项接口 */
export interface SeoItem {
  /** 状态 */
  status: number;
  /** 标题 */
  title: string;
  /** 内容 */
  content: string;
}

/** SEO组件属性接口 */
export interface SeoAttrs extends BaseComponentAttrs {
  /** 标题文本 */
  title: string;
  /** 数据列表 */
  list: SeoItem[];
}

/** SEO组件类 */
export class SeoComponent extends BaseComponent<SeoAttrs> {
  constructor(data: Partial<BaseComponent<SeoAttrs>> = {}) {
    super(data);
    this.type = CompType.seo;
  }

  public getTitle(): string {
    return this?.lang_attrs?.title || "";
  }

  public getList(): SeoItem[] {
    const list = this?.lang_attrs?.list;
    // status 1: 开启，0: 关闭
    const newList = list?.filter((item) => item.status === 1) || [];
    return newList;
  }
}

// 使用示例
// const seoData: Partial<BaseComponent<SeoAttrs>> = {
//   id: "673c87ace755a46fc90130b6",
//   type: CompType.seo,
//   variant: "",
//   title: "",
//   status: 1,
//   sort: 0,
//   login_type: LoginType.Login,
//   recharge_type: RechargeType.Recharge,
//   fixed_top: 0,
//   key: "footer_seo",
//   show_rtp: false,
//   height: "",
//   attrs: {
//     title_text: {
//       "1": "footer_seo",
//       "4": "footer_seo",
//       "11": "footer_seo",
//       "12": "footer_seo",
//     },
//     data_list: [
//       {
//         status: 1,
//         title_lang: {
//           "11": "Como funcionam os slots?",
//           "12": "¿Cómo funcionan las tragamonedas?",
//           "1": "How do slots work?",
//           "4": "老虎機如何運作？",
//         },
//         context_lang: {
//           "1": "<p>To play Afun Slots, it is important to know the basics of how these games work...</p>",
//           "4": "<p>要玩 Afun 老虎機，了解這些遊戲的基礎知識非常重要...</p>",
//           "11": "<p>Para jogar os Afun Slots, é importante saber o básico sobre como esses jogos funcionam...</p>",
//           "12": "<p>Para jugar a Afun Slots, es importante conocer los conceptos básicos de cómo funcionan estos juegos...</p>",
//         },
//         key: 1732267557563,
//       },
//     ],
//   },
// };
